// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"87011631","839":"3057df95"}[chunkId] + ".chunk.js";
};